import type { ComponentProps } from "react";
import type User from "byzantine/src/User";
import EnterYourVerificationCode from "./EnterYourVerificationCode";
import TellUsMoreAboutYou from "./TellUsMoreAboutYou";

type VerifyProps = ComponentProps<typeof TellUsMoreAboutYou> & {
  user?: User | null;
};

const Verify = ({
  user,
  updateUser,
  encodedPayload,
  institution,
}: VerifyProps) => {
  if (user?.requires_enrollment_code_verification) {
    return (
      <EnterYourVerificationCode
        user={user}
        updateUser={updateUser}
        institution={institution}
      />
    );
  }
  return (
    <TellUsMoreAboutYou
      updateUser={updateUser}
      encodedPayload={encodedPayload}
      institution={institution}
    />
  );
};

export default Verify;
